import React from 'react';

const APARIcon = ({ className = '' }) => {
  return (
    <svg
      width="21"
      height="23"
      viewBox="0 0 21 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.50214 17.7857H13.5063M4.49798 14.7857H13.5021M4.49383 11.7857H8.99798M4.49798 7.28571L5.99798 8.28571L8.49798 4.28571M16.4979 16.5L19.8506 6.0332C20.2033 4.93241 19.552 3.76277 18.4306 3.48269L16.4978 3M16.4978 3L16.4979 19.2857C16.4979 20.3903 15.6025 21.2857 14.4979 21.2857H3.49813C2.39356 21.2857 1.49813 20.3903 1.49813 19.2857L1.49805 5.8007V3.28572C1.49805 2.18115 2.39349 1.28571 3.49806 1.28572L14.7837 1.28581C15.7304 1.28582 16.4978 2.05328 16.4978 3V3Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default APARIcon;
